// dependencies
import React, { Fragment } from "react";
import { View, StyleSheet, AccessibilityRole } from "react-native";

// components
import Text from "@cloudspire/legacy-resources/src/components/Text";
import {
  List,
  ListItem,
} from "@cloudspire/legacy-resources/src/components/List";
import FieldError from "./Error";

// libraries
import { emToPx } from "@cloudspire/legacy-resources/src/libraries";

type PropsType = {
  label?: string;
  required?: boolean;
  errorList?: string[];
  help?: React.ReactNode;
  children: React.ReactNode;
};

const styles = StyleSheet.create({
  label: {
    fontSize: emToPx(0.75),
    fontWeight: "500",
  },
  requiredLabel: {
    textAlignVertical: "top",
    color: "#ff0000",
    userSelect: "none",
    fontSize: emToPx(1),
    lineHeight: emToPx(0.75),
  },
  help: {
    fontSize: emToPx(0.75),
    color: "#23b7e5",
  },
});

const Field: React.FunctionComponent<PropsType> = (props) => {
  const { label, errorList = [], required = false, help, children } = props;

  return (
    <View accessibilityRole={"label" as AccessibilityRole}>
      <List gutter={0.3125}>
        {null != label && (
          <ListItem>
            <Text ellipsizeMode="tail" numberOfLines={1} style={styles.label}>
              {label}
              {required && (
                <Text style={styles.requiredLabel}>{"\u202f*"}</Text>
              )}
            </Text>
          </ListItem>
        )}

        <ListItem>{children}</ListItem>

        {errorList.length > 0 && (
          <ListItem>
            <FieldError errorList={errorList} />
          </ListItem>
        )}

        {help && (
          <Fragment>
            {"string" === typeof help ? (
              <Text style={styles.help}>{help}</Text>
            ) : (
              help
            )}
          </Fragment>
        )}
      </List>
    </View>
  );
};

export default Field;
